export const DTX_APP_ID: string = 'dtx-app-ID';

export const DTX_TOP_AD_TAG = '2561520';
export const DTX_BOTTOM_AD_TAG = '2579197';
export const DTX_ADHESION_AD_TAG = '2561519';
export const DTX_INTERSTITIAL_AD_TAG = '2459539';
export const DTX_PUBLISHER_ID = '208585';
